import { render } from "./viewPayslipsTemplates.vue?vue&type=template&id=1a02bb50"
import script from "./viewPayslipsTemplates.vue?vue&type=script&lang=js"
export * from "./viewPayslipsTemplates.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__